import React from "react";
import PropTypes from "prop-types";
import { useInView } from "react-intersection-observer";

// components
import StepCard from "../../Cards/StepCard";

// styles
import * as styles from "./TechnologyCard.module.css";

// images - step numbers
import step01 from "../../../images/doctor/01.png";
import step02 from "../../../images/doctor/02.png";
import step03 from "../../../images/doctor/03.png";
import step04 from "../../../images/doctor/04.png";

// images - step icons
import patientIcon from "../../../images/doctor/patient-icn.png";
import monitorIcon from "../../../images/doctor/monitor-icn.png";
import supportIcon from "../../../images/doctor/support-icn.png";
import resultIcon from "../../../images/doctor/result-icn.png";

const propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
};

const defaultProps = {
  title: "Technology That Strengthens Your Clinical Expertise",
  subtitle:
    "With Twin Health as your healthcare partnership, your patients receive real-time metabolic monitoring, AI-driven insights, and personalised care, while you lead their clinical decisions.",
  description:
    "You focus on clinical care; we provide the technology and data intelligence.",
};

const TechnologyCard = ({ title, subtitle, description }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const stepsData = [
    {
      stepNumber: step01,
      stepIcon: patientIcon,
      title: "Enroll patients through your Twin Health partner dashboard",
      stepIconAlt: "Patient enrollment icon",
      numberIconAlt: "Step 01",
    },
    {
      stepNumber: step02,
      stepIcon: monitorIcon,
      title: "Monitor progress with real-time metabolic insights",
      stepIconAlt: "Monitor progress icon",
      numberIconAlt: "Step 02",
    },
    {
      stepNumber: step03,
      stepIcon: supportIcon,
      title:
        "Guide with data — AI-backed recommendations support your treatment plans",
      stepIconAlt: "AI support icon",
      numberIconAlt: "Step 03",
    },
    {
      stepNumber: step04,
      stepIcon: resultIcon,
      title:
        "See results — measurable improvements in HbA1c, weight, and energy",
      stepIconAlt: "Results icon",
      numberIconAlt: "Step 04",
    },
  ];

  return (
    <section className={styles.technologyCardWrapper}>
      <div
        ref={ref}
        className={`container scroll_animate ${inView && "inview"}`}
      >
        {/* Header Section */}
        <div className={styles.headerSection}>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.subtitle}>{subtitle}</p>
          <p className={styles.description}>{description}</p>
        </div>

        {/* Step Overview Section */}
        <div className={styles.stepOverviewSection}>
          <h3 className={styles.stepOverviewTitle}>Step Overview</h3>
          <StepCard cards={stepsData} />
        </div>
      </div>
    </section>
  );
};

TechnologyCard.propTypes = propTypes;
TechnologyCard.defaultProps = defaultProps;

export default TechnologyCard;
